module.exports = __webpack_public_path__ + "img/tel2.a252ffe6.png";